import React from "react";
import ReactDOM from "react-dom";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import * as Sentry from "@sentry/react";

import App from "./components/App";
import "./i18n";
import "./index.css";
import { initAnalytics, track, consumeOpenSource } from "./services/analytics";

// Font Awesome (importation globale, comme GameTime)
import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free/css/brands.css";
import "@fortawesome/fontawesome-free/css/solid.css";
import "@fortawesome/fontawesome-free/css/regular.css";

// Crash reporting (no-op si REACT_APP_SENTRY_DSN absente)
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: `scholeo@${process.env.REACT_APP_VERSION || "0.1.0"}`,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0,
    sendDefaultPii: false, // aucune donnée personnelle (élèves mineurs)
  });
}

// Analytics produit (no-op si REACT_APP_POSTHOG_KEY absente)
initAnalytics();

try {
  if (!localStorage.getItem("st_first_open_done")) {
    track("app_first_open");
    localStorage.setItem("st_first_open_done", "1");
  }
} catch (e) {
  /* localStorage indisponible : on ignore */
}

track("app_open", { source: consumeOpenSource() });

ReactDOM.render(<App />, document.getElementById("root"));

defineCustomElements(window);
